import { c as _c } from "react/compiler-runtime";
import { getSessionId } from '@onefootprint/dev-tools/';
import { postOrgSdkTelemetryMutation } from '@onefootprint/fetch-hosted/queries';
import { getErrorMessage } from '@onefootprint/request';
import { useMutation } from '@tanstack/react-query';
import type React from 'react';
import type { ErrorInfo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { getLogger } from '@/idv/utils';
import ErrorComponent from './components/error';
type AppErrorBoundaryProps = {
  children: React.ReactNode;
  onReset?: () => void;
};
const {
  logError
} = getLogger({
  location: 'app-error-boundary'
});
const AppErrorBoundary = t0 => {
  const $ = _c(7);
  const {
    children,
    onReset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = postOrgSdkTelemetryMutation();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const mutSdkTelemetry = useMutation(t1);
  let t2;
  if ($[1] !== mutSdkTelemetry) {
    t2 = (error, stack) => {
      const errorMessage = getErrorMessage(error);
      const stackTrace = String(stack.componentStack).slice(0, 100);
      const contextMessage = `AppErrorBoundary, stack: ${stackTrace}`;
      logError(contextMessage, error);
      mutSdkTelemetry.mutate({
        body: {
          logLevel: "error",
          logMessage: `AppErrorBoundary error: ${errorMessage}, stack: ${stackTrace}`,
          sessionId: getSessionId(),
          tenantDomain: window.location.href
        }
      });
    };
    $[1] = mutSdkTelemetry;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleError = t2;
  let t3;
  if ($[3] !== children || $[4] !== handleError || $[5] !== onReset) {
    t3 = <ErrorBoundary FallbackComponent={ErrorComponent} onError={handleError} onReset={onReset}>{children}</ErrorBoundary>;
    $[3] = children;
    $[4] = handleError;
    $[5] = onReset;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default AppErrorBoundary;